const $ = window.jQuery;

if ( $( '.hero-add-to-cart' ).length ) {

	console.log('hello')

	$( '.hero-add-to-cart .subtract' ).click( function() {
		const quantity = getCurrentQuantity();
		if ( quantity === 1 ) {
			return;
		}
		setCurrentQuantity( quantity - 1 );
	} );

	$( '.hero-add-to-cart .add' ).click( function() {
		const quantity = getCurrentQuantity();
		setCurrentQuantity( quantity + 1 );
	} );

	function getCurrentQuantity() {
		return Number.parseInt( $( '.hero-add-to-cart .quantity' ).text() );
	}

	function setCurrentQuantity( quantity ) {
		$( '.hero-add-to-cart .quantity' ).text( quantity );
		$( '.hero-add-to-cart .add_to_cart_button' ).attr( 'data-quantity', quantity );
	}
}
